import { createSlotRecipe } from './runtime.js';

const topNavConfig = {"name":"topNav","slots":["root","start","middle","end"],"defaultVariants":{"hasDivider":true},"variantMap":{"hasDivider":["false","true"]}}

export const topNav = /* @__PURE__ */ createSlotRecipe(topNavConfig)